import {
  Component,
  Injectable,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  EventEmitter
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import {
  FotoBase64ViewModel,
  ParametersOS,
} from "src/app/pages/domain/viewmodels.models";
import { FecharOSService } from "src/app/pages/os/fechar-os/fechar-os.service";
import { Photo } from "src/app/pages/os/fechar-os/photo.model";
import { OSService } from "src/app/services/os-service";
import { ImagemUtil } from "src/app/utils/Imagem.util";
import { Util } from "src/app/utils/util.util";
import { APP_SETTINGS, SCAMP_API_RPT } from "src/environments/environment";
import { IMAGENS_SATISFACAO, VALORES_SATISFACAO } from "./../../shareds/constantes"

@Component({
  selector: "app-detalhes-os",
  templateUrl: "./detalhes-os.component.html",
  styleUrls: ["./detalhes-os.component.scss"],
})
@Injectable()
export class DetalhesOSComponent implements OnInit, OnChanges {
  constructor(
    private osservice: OSService,
    private toastr: ToastrService,
    private fechamentoOSService: FecharOSService,
    private modalService: NgbModal
  ) { }

  @Input() public parameters: ParametersOS;
  @Input() public showRegistroFotografico = true;
  @Input() public showMateriais = true;
  @Input() public showIrregularidades = true;
  @Input() public showDadosRealizacao = true;
  @Input() public showButtonImprimirOSComEvidenciaFotos = true;
  @Input() public showButtonImprimirOSSemEvidenciaFotos = true;
  @Input() public msgButtonFechar = "Fechar";
  @Input() public showButtonLiberarOSParaExecucao = false;
  @Input() public showButtonCancelarOS = false;

  @ViewChild("modal") private modalContent: TemplateRef<DetalhesOSComponent>;

  @Output() public cancelarOS = new EventEmitter();
  @Output() public qualificarOS = new EventEmitter();

  public OS: any = null;
  files: File[] = []; // armazena os arquivo de fotos
  filesAntes: File[] = [];
  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewsPhotosAntes: Photo[] = []; // armazena as photos em base 64 para exibição
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  public imagens_satisfacao: string[] = IMAGENS_SATISFACAO;
  public valores_satisfacao: string[] = VALORES_SATISFACAO;

  isProcessing: boolean = false;
  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.parameters != undefined) {
      if (changes.parameters) {
        setTimeout(() => {
          this.getById();
        });
      }
    }
  }

  openModal() {
    this.modalService.open(this.modalContent, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  public fecharModal() {
    this.modalService.dismissAll();
    this.OS = null;
    this.files = [];
    this.filesAntes = [];
    this.previewsPhotos = [];
    this.previewsPhotosAntes = [];
    this.parameters = undefined;
    this.isProcessing = false;
  }

  getById() {
    this.osservice
      .getOSCompleta(this.parameters.osId, this.parameters.spvId)
      .subscribe(
        (response) => {
          this.OS = response;

          this.fechamentoOSService
            .getArrayFotosBase64(this.OS.uploadPhotos)
            .subscribe((responseFotos: FotoBase64ViewModel[]) => {
              responseFotos.forEach((foto) => {
                this.handleFile(
                  [].concat(
                    Util.dataURLtoFile(foto.base64String, foto.arquivoNome)
                  ),
                  false
                );
                this.previewsPhotos.push({
                  dataUrl: foto.base64String,
                  name: foto.arquivoNome,
                });
              });
            });

          this.fechamentoOSService
            .getArrayFotosBase64(this.OS.fotosAntes)
            .subscribe((responseFotos: FotoBase64ViewModel[]) => {
              responseFotos.forEach((foto) => {
                this.handleFileAntes(
                  [].concat(
                    Util.dataURLtoFile(foto.base64String, foto.arquivoNome)
                  ),
                  false
                );
                this.previewsPhotosAntes.push({
                  dataUrl: foto.base64String,
                  name: foto.arquivoNome,
                });
              });
            });

          this.openModal();
        },
        (err: any) => {
          this.toastr.error(
            `Ocorreu um erro no servidor.<br /><br /> ${err.error}`
          );
        }
      );
  }

  handleFile(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.filesAntes,
      this.previewsPhotosAntes,
      true,
      addPreviewsPhotos
    );
  }

  handleFileAntes(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.filesAntes,
      this.previewsPhotosAntes,
      true,
      addPreviewsPhotos
    );
  }

  reimprimirOS(comEvidenciaDeFotos: boolean) {
    this.isProcessing = true;

    this.osservice
      .imprimirOS(
        this.parameters.osId,
        this.OS.tipoOSFilha,
        comEvidenciaDeFotos ? "S" : "N"
      )
      .subscribe(
        (response) => {
          if (response.success === true) {
            if (response.nenhumResultado === false) {
              window.open(
                `${SCAMP_API_RPT.root}${response.pathRpt}`,
                "_blank",
                "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
              );
            } else {
              this.toastr.warning(response.msgErro);
            }
          } else {
            this.toastr.error(response.msgErro);
          }
          this.isProcessing = false;
        },
        (err: any) => {
          this.toastr.error(
            "Não foi possível se conectar ao servidor de relatórios",
            "Erro de Conexão"
          );
          this.isProcessing = false;
        }
      );
  }

  cancelarOSEmitter() {
    this.cancelarOS.emit(this.OS.osId)
  }

  qualificarOSEmitter() {
    this.qualificarOS.emit(this.OS.osId)
  }
}
